import { useTheme } from '@mui/material';
import type { SvgIconProps } from '@mui/material';

import RiskReportDocLight from './RiskReportDocLight.svg';
import RiskReportDocDark from './RiskReportDocDark.svg';

const RiskReportDoc = (props: SvgIconProps) => {
  const theme = useTheme();
  const IconForTheme =
    theme.palette.mode == 'light' ? RiskReportDocLight : RiskReportDocDark;

  return <IconForTheme {...props} />;
};

export default RiskReportDoc;
